import { Environment } from '@abp/ng.core';
import { EnvContants } from './env.service.provider';


export const environment = {
  production: EnvContants.production,
  application: EnvContants.application,
  oAuthConfig: EnvContants.oAuthConfig,
  apis: EnvContants.apis
} as Environment;
